import randomColor from 'randomcolor'

const randomColorForString = (...strings) =>
  randomColor({ seed: strings.join(' '), luminosity: 'bright' })

export default randomColorForString
